<div class="page-container" style="min-height:188.38330078125px">
  <div class="page-content text-center">
    <div class="panel panel-flat">
      <div class="panel-body">
        <div class="row">
          <br><br>
          <div><i class="icon-checkmark-circle2" style="font-size: 12em; color:#69A74E"></i></div>
          <br>
          <div *ngIf="action == 'register'">
            <p translate>Thank You</p>
            <p translate [innerHTML]="'PAYMENT_RESULT_REGISTER' | translate:{period:translate.instant(period),plan:translate.instant(plan)}"></p>
          </div>

          <div *ngIf="action == 'upgrade'">
            <p translate>Thank You</p>
            <p translate [innerHTML]="'PAYMENT_RESULT_UPGRADE' | translate:{period:translate.instant(period),plan:translate.instant(plan)}"></p>
          </div>

          <div *ngIf="action == 'update'">
            <p translate>Thank You</p>
            <p translate>Your credit card information has been changed.</p>
          </div>

          <div *ngIf="stripePaymentStatus == 'succeeded' && !action">
            <p translate>Thank You</p>
            <p translate>Your payment has been processed successfully via Stripe.</p>
          </div>

          <div *ngIf="stripePaymentStatus == 'processing' && !action">
            <p translate>Payment Processing</p>
            <p translate>Your payment is being processed. You will receive a confirmation shortly.</p>
          </div>

          <div *ngIf="stripePaymentStatus == 'requires_payment_method' && !action">
            <div><i class="icon-cross" style="font-size: 12em; color:red"></i></div>
            <br>
            <p translate>Payment Failed</p>
            <p translate>Your payment was not successful. Please try again.</p>
          </div>

          <div *ngIf="stripePaymentStatus == 'load_error' && !action">
            <div><i class="icon-cross" style="font-size: 12em; color:red"></i></div>
            <br>
            <p translate>Payment Verification Error</p>
            <p translate>Could not verify payment status. Please check your account or try again later.</p>
          </div>

          <button class="btn btn-primary" (click)="router.navigate(['/account'])" >{{translate.instant("Back to the profile page")}}</button>
          <br>
        </div>
      </div>
    </div>
  </div>
</div>
